import { Component, OnInit } from '@angular/core';
import { guidePath, MarketGuidesService, Publication, ukDay } from '../market-guides.service';

/**
 * /market-guides: the Market Guides library inside Insights & Opinion.
 * Lists every published guide from the API, newest first; a new guide is a
 * new publications row, not a code change.
 */
@Component({
  selector: 'pla-guides-library',
  templateUrl: './guides-library.component.html',
  styleUrls: ['./guides-library.component.scss'],
})
export class GuidesLibraryComponent implements OnInit {
  public guides: Publication[] = [];
  public state: 'loading' | 'ready' | 'error' = 'loading';
  public readonly path = guidePath;

  constructor(private service: MarketGuidesService) {}

  ngOnInit(): void {
    this.service.list().subscribe({
      next: (g) => {
        this.guides = g;
        this.state = 'ready';
      },
      error: () => (this.state = 'error'),
    });
  }

  status(g: Publication): string {
    if (g.access.entitled) return 'In your account';
    if (g.phase === 'complimentary') {
      const end = g.complimentaryEndsAt ? ukDay(new Date(Date.parse(g.complimentaryEndsAt) - 60000).toISOString()) : '';
      return end ? `Free to claim until ${end}` : 'Free to claim';
    }
    if (g.phase === 'upcoming') return 'Coming soon';
    return '';
  }
}
